import Headroom from "headroom.js";

let header;

function init() {
    header = document.querySelector(".page-header");

    if (header && header.classList.contains("headroom")) {
        let offset = header.querySelector(".top-bar").clientHeight;
        let headr = new Headroom(header, {
            //tolerance: 0,
            offset: offset
        });
        headr.init();
    }
}

_gg.domJsReady(init);
